import { usePlatformBranding } from '@/core/platform-branding';
import { darkenHex } from '@/core/platform-branding/platform-branding';
import { LoginForm } from './components/LoginForm';

export function LoginPage() {
  const { branding } = usePlatformBranding();
  const gradientTo = darkenHex(branding.primaryColor, 0.12);

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: `linear-gradient(to bottom right, ${branding.primaryColor}, ${gradientTo})`,
      }}
    >
      <LoginForm />
    </div>
  );
}
